export const LOCAL_STORE_PREFIX = 'pc-performance-fraud-directory-microsite'
export const STATE_KEY = 'state'
